import clsx from 'clsx';
import React from 'react';
import { bemComponent } from '../../../../utils/app';

interface Props {
    hasHeader?: boolean;
    children?: React.ReactNode;
}

export const Main: React.FC<Props> = ({ hasHeader, children }) => (
    <div
        className={clsx({
            'fullscreen-main': true,
            'fullscreen-main--has-header': hasHeader,
        })}
    >
        {children}
    </div>
);

export const Header = bemComponent('fullscreen-main__header', 'Header');
export const Body = bemComponent('fullscreen-main__body', 'Body');
